<ng-container *ngIf="customTemplate; else defaultTemplate">
    <ng-container *ngTemplateOutlet="customTemplate; context: npmcContext"></ng-container>
</ng-container>
<ng-template #defaultTemplate>
    <ul class="np-multi-checkbox">
        @for(item of items;track $index) {
        <li [ngStyle]="{'min-width': minWidth}">
            <label>
                <input type="checkbox" [checked]="selected[item[valuePath]]" (click)="select(item[valuePath])"
                    [disabled]="disabled"> {{item[textPath]}}
            </label>
        </li>
        }
    </ul>
</ng-template>